<style scoped>
.explain {
  background: #fff;
  border-radius: 4px;
  text-align: left;
  margin: 20px 14px;
  overflow: hidden;
  padding: 0 20px 30px 20px;
}
.explain-header {
  padding: 20px 0;
  overflow: hidden;
  /* border-bottom: 1px solid #ccc; */
}
.explain-header b {
  font-size: 20px;
  font-weight: 400;
  color: #323233;
}
.explain-contain {
  padding: 20px 20px 30px 60px;
}
.explain-title {
  /* width: 130px; */
  display: inline-block;
}
.cost-img {
  width: 300px;
}
.state-approval {
  font-size: 12px;
  display: inline-block;
  padding: 3px 10px 4px 10px;
  border-radius: 10px;
  margin-left: 20px;
}

.now-state {
  width: 112px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  box-sizing: border-box;
}
.state-now-pass {
  color: #fff;
  background: #4fa1a4;
}
.state-now-unpass {
  color: red;
  border: 1px solid red;
}
.state-now-revoke {
  color: #4fa1a4;
  border: 1px solid #4fa1a4;
}
.state-back {
  width: 84px;
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #323233;
  text-align: center;
  cursor: pointer;
  border: 1px solid #c8c9cd;
}
.approval {
  margin: 10px 10px 60px 10px;
  background: #fff;
  border-radius: 4px;
  text-align: left;
  padding: 30px 60px 60px 60px;
}
.approval-list {
  display: flex;
}
.list-left {
  margin-right: 10px;
}
.left-box {
  width: 55px;
  height: 55px;
  color: #fff;
  line-height: 51px;
  background: #999;
  text-align: center;
  border-radius: 4px;
  margin: 0px 10px;
}
.left-line {
  width: 0.5px;
  height: 40px;
  background: #999;
  margin-left: 37px;
}
.approval-list:last-child .list-left .left-line {
  display: none;
}
/deep/.el-dialog__body {
  padding: 10px 20px;
}
.state-now {
  color: #e59940;
  background: rgba(255, 242, 224, 0.23);
  /* border: 1px solid #e59940; */
  /* border: 1px solid #C8C9CD; */
}
.state-pass {
  color: #4fa1a4;
  background: rgba(79, 161, 164, 0.1);
  /* border: 1px solid #4fa1a4; */
}
.state-reject {
  color: rgb(255, 85, 85);
  background: rgba(255, 85, 85, 0.07);
  /* border: 1px solid rgb(255, 85, 85); */
}
.state-undo {
  color: rgb(197, 202, 213);
  background: #fff;
  border: 1px solid rgb(197, 202, 213);
}
.title-pass {
  background: #4fa1a4 !important;
}
.title-reject {
  background: red !important;
}
.explain-item {
  line-height: 40px;
  display: flex;
}
.explain-title {
  flex-shrink: 0;
}
.explain-content {
  display: inline-block;
  /* line-height: 30px; */
}
.link-active {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
.doc-img {
  width: 80px;
  height: 80px;
  margin-right: 24px;
  /* margin-bottom: 10px; */
  cursor: pointer;
}
.doc-img img {
  width: 80px;
  height: 80px;
}
.img-name {
  width: 80px;
  line-height: 20px;
  margin-bottom: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: default;
}
 .content {
  margin: 0px;
 }
 .iframe-sty{ 
  width:100%;
  height: 800px; 
  border:none; 
 }
</style>
<template>
  <div class="approval-detail" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="explain">
      <div class="explain-header">
        <b class="font-S20">{{ flowName }}</b>
        <span class="state-approval state-now" v-if="costDetail.approveState == 'N' || costDetail.approveState == 'A'">审批中</span>
        <span class="state-approval state-pass" v-if="costDetail.approveState == 'Y'">已通过</span>
        <span class="state-approval state-reject" v-if="costDetail.approveState == 'R'">已驳回</span>
        <span class="state-approval state-undo" v-if="costDetail.approveState == 'C'">已撤销</span>
        <span :class="costDetail.approveState == 'Y' ? 'state-back fr' : 'state-back fr ml30'" @click="$router.go(-1)">返回</span>
        <span class="state-back fr mr15 ml30" v-if="costDetail.approveState == 'Y'" @click="toPrinting()">打印</span>
        <span class="now-state state-now-unpass fr mr15" v-if="approveStaffGuid == staffGuid && (costDetail.approveState == 'N' || costDetail.approveState == 'A')" @click="toReject()">驳回</span>
        <span class="now-state state-now-pass fr mr15" v-if="approveStaffGuid == staffGuid && (costDetail.approveState == 'N' || costDetail.approveState == 'A')" @click="toPass()">通过</span>
        <span class="now-state state-now-pass fr mr15" v-if="costDetail.approveState == 'R' && costDetail.staffGuid == staffGuid" @click="reSubmit()">重新提交</span>
        <span class="now-state state-now-revoke fr mr15" v-if="costDetail.approveState == 'N' && costDetail.staffGuid == staffGuid" @click="toRevoke()">撤销</span>
      </div>
      <div class="cost-title-list">
        <span class="cost-title-list-line"></span>
        <span class="cost-title-list-txt">申请信息</span>
      </div>
      <div class="explain-contain">
        <div class="explain-item">
          <span class="explain-title">申请人：</span> <span class="explain-content">{{ costDetail.staffName }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">提交时间：</span>
          <span class="explain-content">{{ costDetail.createTime | getTime }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">所在部门：</span>
          <span class="explain-content">{{ costDetail.organisationName }}</span>
        </div>
          <div class="explain-item">
          <span class="explain-title">会议名称：</span>
          <span class="explain-content">{{ costDetail.projectName }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">会议内容：</span>
          <span class="explain-content">{{ costDetail.applySubject }}</span>
        </div>
          <div class="explain-item">
          <span class="explain-title">学术计划：</span>
          <span class="explain-content">{{ costDetail.isPlan=='Y'?'在当月内':'不在当月内'}}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">会议类别：</span>
          <span class="explain-content">{{ costDetail.meetingTypeName}}</span>
        </div>
        <!-- <div class="explain-item">
          <span class="explain-title">参与人员：</span>
          <span class="explain-content">{{ costDetail.joinStaff }}</span>
        </div> -->
        <div class="explain-item" v-if="costDetail.meetingBodyType">
          <span class="explain-title">主体类型：</span>
          <span class="explain-content">{{ costDetail.meetingBodyType | meetingBodyType}}</span>
        </div>
        <div class="explain-item"  v-if="costDetail.franchiseeName">
          <span class="explain-title">参会主体：</span>
          <span class="explain-content">{{ costDetail.franchiseeName }}</span>
        </div>
        <div class="explain-item"  v-if="costDetail.meetingBodyType == '3'">
          <span class="explain-title">参会主体：</span>
          <span class="explain-content">{{ costDetail.meetingBody }}</span>
        </div>
        <!-- <div class="explain-item">
          <span class="explain-title">会议名称：</span>
          <span class="explain-content">{{ costDetail.applySubject }}</span>
        </div> -->
        <div class="explain-item">
          <span class="explain-title">费用金额：</span>
          <span class="explain-content">{{ costDetail.amount | numDigit }} 元</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">大写金额：</span>
          <span class="explain-content">{{ costDetail.amount | smallToBig }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">发生日期：</span>
          <span class="explain-content">{{ costDetail.occurTime | getDate }}</span>
        </div>
        <div class="explain-item clear-hidden">
          <span class="explain-title fl">费用申请表：</span>
          <template v-for="(item, index) in imgList">
            <div class="img-block" v-if="imgList" :key="index">
              <el-tooltip class="item" effect="dark" :content="item.name || item.fileName" placement="right">
                <el-image style="width: 80px; height: 80px; margin-right: 24px" :src="item.path" :preview-src-list="imgPreviewList"></el-image>
              </el-tooltip>
            </div>
          </template>
          <template v-for="(item, index) in docList">
            <div class="doc-img" v-if="docList" :key="index">
              <el-tooltip class="item" effect="dark" :content="item.name|| item.fileName " placement="right">
              <img :src="item.icon" alt="" @click="toFile(item.path)" />
              </el-tooltip>
            </div>
          </template>
        </div>
      </div>
      <div class="cost-title-list mb25" v-if="!iframeSh">
        <span class="cost-title-list-line"></span>
        <span class="cost-title-list-txt">流程审批</span>
      </div>
      <flowList :approvalList="approvalList" v-if="!iframeSh" :carbonName="carbonName" :approveState="costDetail.approveState"></flowList>
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>
    <div class="h20"></div>
      <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
        <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest"> </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
        </span>
      </el-dialog> 
      <el-dialog title="通过流程" :visible.sync="passDialogVisible" width="30%" top="15%">
        <el-input type="textarea" :rows="5" placeholder="输入通过备注（非必填）" v-model="approveSuggest"> </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
        </span>
      </el-dialog> 
    <el-dialog title="文件查看" :visible.sync="dialogVisibleFile" fullscreen>
      <!-- <span>这是一段信息</span> -->
      <iframe style="width: 100%; height: calc(100vh - 84px)" :src="src" frameborder="0"></iframe>
    </el-dialog>
    <printDialog :showPrintDialog.sync='showPrint' :printData="costDetail" :approvalList="approvalList" @closePrint="closePrint"></printDialog>
  </div>
</template>
<script>
import flowList from '@/components/flowList.vue';
import printDialog from '@/components/printDialog.vue';
import { bpmnroute } from '../../api/apiRoute';
export default {
  components: {
    flowList,
    printDialog
  },
  data() {
    return {
      rejectDialogVisible:false,
      passDialogVisible:false,
      dialogVisibleFile:false,
      costDetail: {},
      approveSuggest: '',
      flowName: '会议任务申请',
      carbonName: '',
      approvalList: [],
      approveStaffGuid: '',
      staffGuid: '',
      imgList: [],
      url: '',
      flowType: '00001',
      fullscreenLoading: false,
      docList: [],
      src: '',
      imgPreviewList: [],
      showPrint:false, //打印
      srcs:'',
      processInstanceId:'',
      iframeSh:false,
    };
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.staffGuid = userinfo.staffGuid;
    this.approveStaffGuid = this.$route.query.approveStaffGuid;
    this.getData();
    this.getApprovalList();
    console.log(this.imgList);
    if(this.$route.query.camundaInstanceId && this.$route.query.camundaDeploymentId){
      // this.getToken(); 
      this.setSrcs();
    } 
    
  },
  methods: {
    setSrcs() { 
      this.iframeSh = true;
      this.srcs = bpmnroute + '/iframeBpmn?processInstanceId='+this.$route.query.camundaInstanceId + '&camundaDeploymentId='+ this.$route.query.camundaDeploymentId+'&token='+ localStorage.token;
    },
    getToken(){
      let self = this; 
      self.api.postJson(`/csbr-zuul/user/refreshToken?token=${localStorage.token}`).then(res => {
        if (res.data.msg == "token延期成功!") {
          let token = res.data.data.refreshToken; 
          if(self.$route.query.camundaInstanceId && self.$route.query.camundaDeploymentId){
            self.iframeSh = true;
            self.srcs = bpmnroute + '/iframeBpmn?processInstanceId='+self.$route.query.camundaInstanceId + '&camundaDeploymentId='+ self.$route.query.camundaDeploymentId+'&token='+token;
          }
          // self.srcs = 'http://192.168.2.175:9001/iframeBpmn?processInstanceId='+this.$route.query.camundaInstanceId + '&camundaDeploymentId='+ self.$route.query.camundaDeploymentId;
          // self.srcs = 'http://117.78.34.191:8925/bpmn?token='+ token + '&flowTemplateGuid='+ self.$route.query.flowTemplateGuid + '&deploymentId='+ self.$route.query.deploymentId + '&tenantGuid='+ self.$route.query.tenantGuid + '&flowName='+ self.$route.query.flowName;
          // self.srcs = 'http://192.168.2.175:9001/bpmn?token='+ token + '&flowTemplateGuid='+ self.$route.query.flowTemplateGuid + '&deploymentId='+ self.$route.query.deploymentId + '&tenantGuid='+ self.$route.query.tenantGuid + '&flowName='+ self.$route.query.flowName;
        }
      })
    },
    //打印
    closePrint(){
      this.showPrint = false
    },
    getMeetingType() {
      let that = this;
      that.api.get(
        `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${localStorage.guid}&code=HYLB`
      ).then((resp) => {
        if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = resp.data.data;
          let arr = [];
          console.log(data);
          data.forEach((item) => {
            if(item.parameterValue == that.costDetail.meetingKind){
              that.costDetail.meetingTypeName = item.name;
            }
          });
          this.$forceUpdate();

        } else {
              self.$message.error(res.data.msg);
        }
      });
    },
    getData() {
      let self = this;
      this.fullscreenLoading = true;
      self.api
        .postCan(`/${serverConfig.msSalesPerformService}/flow/data/get-cost-detail?guid=` + self.$route.query.bizGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.costDetail = res.data.data;
            if(self.costDetail.customerType == '商业公司'){
              self.costDetail.meetingBodyType = '2';
            }else if(self.costDetail.customerType == '医院'){
              self.costDetail.meetingBodyType = '1';
            }
            self.imgList = [];
            let meetingKind = self.costDetail.meetingKind.split("，");
            let meetingKindChild = self.costDetail.meetingKindChild;
            if (meetingKindChild) {
              self.costDetail.meetingTypeName = meetingKind[0] + '-' + meetingKindChild
            } else if (meetingKind[1]) {
              self.costDetail.meetingTypeName = meetingKind[0] + '-' + meetingKind[1]
            } else {
              self.getMeetingType();
            }
            if (res.data.data.applyForm !== null) {
              let applyForm = JSON.parse(res.data.data.applyForm);
              applyForm.forEach((item) => {
                if (
                  item.path.indexOf('.jpg') > -1 ||
                  item.path.indexOf('.png') > -1 ||
                  item.path.indexOf('.jpeg') > -1 ||
                  item.path.indexOf('.jfif') > -1 ||
                  item.path.indexOf('.gif') > -1
                ) {
                  self.imgList.push(item);
                  self.imgPreviewList.push(item.path);
                } else if (item.path.indexOf('.doc') > -1 || item.path.indexOf('.docx') > -1) {
                  item.icon = require('../../assets/images/word_icon.png');
                  self.docList.push(item);
                } else if (item.path.indexOf('.xls') > -1 || item.path.indexOf('.xlsx') > -1) {
                  item.icon = require('../../assets/images/excel_icon.png');
                  self.docList.push(item);
                }
              });
              console.log(self.imgList);
            }
            this.fullscreenLoading = false;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //查看文件 
    toFile(path) {
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(path),'_blank');
    },
    //获取流程列表
    getApprovalList() {
      let self = this;
      self.api
        .postCan(
          `/${serverConfig.msSalesPerformService}/approve/data/get-flow-running-node?flowType=00001&guid=` + self.$route.query.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let ccGuids = '';
            let data = res.data.data;
            if(data){
              data.forEach((i)=>{
                if(i.flowNodeType== 2 && i.ccGuids != '[]'){
                  ccGuids = i.ccGuids;
                }
              })
              self.approvalList = data; 
              if(self.approvalList){
                self.approvalList.sort((n1, n2) => {
                  return n1.orderNum - n2.orderNum;
                });
                self.approvalList.forEach((j)=>{  
                  if(ccGuids){
                    j.ccGuids = ccGuids;
                  } 
                })
                if(res.data.data && res.data.data[0].ccGuids != '[]'){ 
                  self.carbonName = JSON.parse(res.data.data[0].ccGuids)[0].name; 
                }
              }
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //打印
    toPrinting() {
      this.showPrint = true
      // let self = this;
      // self.$router.push({
      //   path: '/reportProcess',
      //   query: {
      //     guid: self.$route.query.guid,
      //     flowType: '00001',
      //   },
      // });
    },

    //撤销
    toRevoke() {
      let self = this;
      self
        .$confirm('确定撤销吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let query = {
            guid: self.$route.query.guid,
            flowType: self.flowType,
            approveStaffGuid:self.staffGuid
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('撤销成功！');
              sessionStorage.refresh = 1;
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    //重新提交
    reSubmit() {
      this.$router.push({
        path: '/costApprove',
        query: {
          bizGuid:this.$route.query.bizGuid,
          guid: this.$route.query.guid,
          productGuid:this.$route.query.productGuid
        },
      });
    },
    toPass(){
      let self = this;
      self.approveSuggest =""
      self.passDialogVisible = true;
    },
    toReject() {
      let self = this;
      self.approveSuggest =""
      self.rejectDialogVisible = true;
    },
    //通过
    toPassSubmit() {
      let self = this;
      let query = {
        guid: self.$route.query.guid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.staffGuid
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/allow-flow`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false;
          self.$message.success('审批通过！');
          sessionStorage.refresh = 1;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //驳回
    toRejectSubmit() {
      let self = this;
      if (self.approveSuggest == '') {
        self.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: self.$route.query.guid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.staffGuid
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/backup-flow`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false;
          self.$message.success('驳回成功！');
          sessionStorage.refresh = 1;
          self.rejectDialogVisible = false;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script> 